<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    title="详细"
    width="70%"
    height="70%"
    @show="showModal"
  >
    <div class="textareaContainer">
      <el-form
        :model="form"
        ref="FormRef"
        :validate-on-rule-change="false"
        :rules="rules"
        size="small"
      >
        <el-form-item label="步骤" prop="todo99">
          <el-input
            type="textarea"
            :rows="isParent ? 20 : 10"
            v-model="form.todo99"
            autocomplete="off"
            :placeholder="placeholderConfig.input"
          ></el-input>
          <template slot="error" slot-scope="slot">
            <errorTooltip :content="slot.error"></errorTooltip>
          </template>
        </el-form-item>
        <el-form-item v-if="!isParent" label="预期" prop="todo98">
          <el-input
            type="textarea"
            rows="10"
            v-model="form.todo98"
            autocomplete="off"
            :placeholder="placeholderConfig.input"
          ></el-input>
          <template slot="error" slot-scope="slot">
            <errorTooltip :content="slot.error"></errorTooltip>
          </template>
        </el-form-item>
      </el-form>
    </div>
    <div class="buttonContainer">
      <el-button @click="handleCancle()" size="mini">取消 </el-button>
      <el-button @click="handleCommit()" size="mini" type="primary"
        >确认
      </el-button>
    </div>
  </vxe-modal>
</template>
<script>
export default {
  props: {
    // 修改行
    updateRow: {
      type: Object
    },
    // 是否为父节点编辑
    isParent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 窗口是否显示
      formVisible: false,
      // 表单
      form: {
        todo99: '',
        todo98: ''
      },
      // 表单校验
      rules: {

      }
    }
  },
  methods: {
    // 校验
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    },
    // 确认
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      this.updateRow['todo99'] = this.form.todo99
      this.updateRow['todo98'] = this.form.todo98
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
    // 取消
    handleCancle() {
      this.formVisible = false
    },
    // 进入窗口时事件
    showModal() {
      // 校验规则 ==> 如果是父节点进入不校验预期字段，否则就都校验
      this.rules = {
        todo99: [
          { required: true, message: '请输入步骤', trigger: 'change' },
        ]
      }
      if (!this.isParent) {
        this.rules['todo98'] = [
          { required: true, message: '请输入预期', trigger: 'change' },
        ]
      } else {
        this.rules['todo98'] = []
      }
      this.form.todo99 = this.updateRow['todo99']
      this.form.todo98 = this.updateRow['todo98']
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    }
  }
}
</script>
<style lang='less' scoped>
.textareaContainer {
  overflow: auto;
  height: calc(100% - 38px);
  width: 100%;
}
.buttonContainer {
  box-sizing: border-box;
  padding-top: 10px;
  height: 38px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>